export default function partnerForm() {
  const locale = document.documentElement.lang || 'ro'
  const baseUrl = locale !== 'ro' ? `/${locale}` : ''

  return {
    isSubmitting: false,
    isDialogOpen: {
      successDialog: false,
      errorDialog: false
    },
    errors: [],
    serverErrors: {},
    data: {
      name: '',
      company: '',
      email: '',
      phone: '',
      message: '',
      agreements: false,
    },

    init() {
      // Clear field errors when user starts typing
      const fields = ['name', 'company', 'email', 'phone', 'message', 'agreements']
      fields.forEach(field => {
        this.$watch(`data.${field}`, () => {
          this.clearFieldError(field)
        })
      })
    },

    openDialog(dialog) {
      this.isDialogOpen[dialog] = true
    },

    closeDialog(dialog) {
      this.isDialogOpen[dialog] = false
    },

    get isValid() {
      if (!this.data.name.trim()) return false
      if (!this.data.company.trim()) return false
      if (!this.data.email.trim() || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.data.email)) return false
      if (!this.data.phone) return false
      if (!this.data.agreements) return false
      return true
    },

    getFieldError(field) {
      return this.serverErrors[field] ? this.serverErrors[field][0] : null
    },

    hasError(field) {
      return this.errors.includes(field) || !!this.serverErrors[field]
    },

    clearFieldError(field) {
      this.errors = this.errors.filter(e => e !== field)
      delete this.serverErrors[field]
    },

    async handleSubmit() {
      this.errors = []
      this.serverErrors = {}

      if (!this.isValid) {
        // Mark invalid fields as errors
        if (!this.data.name.trim()) this.errors.push('name')
        if (!this.data.company.trim()) this.errors.push('company')
        if (!this.data.email.trim() || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.data.email)) {
          this.errors.push('email')
        }
        if (!this.data.phone) {
          this.errors.push('phone')
        }
        if (!this.data.agreements) this.errors.push('agreements')
        return
      }

      this.isSubmitting = true

      try {
        const payload = {
          name: this.data.name.trim(),
          company: this.data.company.trim(),
          email: this.data.email.trim(),
          phone: this.data.phone.replace(/\s/g, ''),
          message: this.data.message.trim() || '',
          agreements: this.data.agreements
        }

        await axios.post(`${baseUrl}/partners/apply`, payload, {
          headers: {
            'Content-Type': 'application/json',
            'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').content
          }
        })

        // Success - show dialog and reset
        this.openDialog('successDialog')
        this.resetForm()
      } catch (e) {
        if (e.response?.status === 422) {
          // Validation errors from server
          this.serverErrors = e.response.data.errors || {}
          this.errors = Object.keys(this.serverErrors)
        } else {
          // General error
          this.openDialog('errorDialog')
        }
      } finally {
        this.isSubmitting = false
      }
    },

    resetForm() {
      this.data = {
        name: '',
        company: '',
        email: '',
        phone: '',
        message: '',
        agreements: false,
      }
      this.errors = []
      this.serverErrors = {}
    },
  }
}
